import React from 'react';
import { Link } from 'react-router-dom';
import { tickerFacts } from '../../data/populations';
import { useScenario } from '../../contexts/ScenarioContext';
import { SourceRef } from '../SourceRef';
import { UtcClock } from './UtcClock';
import { ThemeSwitcher } from './ThemeSwitcher';
export function Ticker() {
  const {
    scenario
  } = useScenario();
  const loop = [...tickerFacts, ...tickerFacts];
  return <div className="relative h-8 overflow-hidden border-b border-line bg-surface" data-id="element-439" data-mp="o5agzltjf2w">
      <div className="absolute left-0 top-0 z-10 flex h-full items-center gap-2 border-r border-line bg-surface px-3 font-mono text-[10.5px] text-machine" data-id="element-440" data-mp="5loru8dtc7z2">
        <span className="h-1.5 w-1.5 rounded-full bg-machine" aria-hidden="true" data-id="element-441" data-mp="ane3nq8v0po7" />
        <span className="hidden sm:inline" data-id="element-442" data-mp="eo7qsheha0g1">agentpopulation.com</span>
        <span className="sm:hidden" data-id="element-443" data-mp="1lzev5cx3ys7n">wire</span>
      </div>
      <ul className="census-marquee flex h-full w-max items-center pl-20 sm:pl-44" aria-label="Sourced facts from agentpopulation.com" data-id="element-444" data-mp="1q21r9q0tazan">
        {loop.map((f, i) => <li key={i} className="flex items-center whitespace-nowrap px-6 font-mono text-[11.5px] text-muted" aria-hidden={i >= tickerFacts.length} data-id="element-445" data-mp="25pvkk11k2w2y" data-mpi={i}>
            <span className="text-ink/85" data-id="element-446" data-mp="1vrxx3frit3be">{f.text}</span>
            <SourceRef id={f.sourceId} data-id="element-447" data-mp="1vqnz0qko3v4r" />
            <span className="ml-6 text-faint" aria-hidden="true" data-id="element-448" data-mp="1rrf2xf25nl61">
              /
            </span>
          </li>)}
      </ul>
      <div className="absolute right-0 top-0 z-10 flex h-full items-center gap-4 border-l border-line bg-surface px-3" data-id="element-449" data-mp="1msklohju64o1">
        <Link to="/" className="hidden whitespace-nowrap font-mono text-[11px] text-muted hover:text-ink sm:inline" title="Active scenario — change it on the Census page" data-id="element-450" data-mp="1hzrdtkt2mg7q">
          Scenario <span className="text-machine" data-id="element-451" data-mp="184he53q5akx4">{scenario.label}</span>
        </Link>
        <UtcClock data-id="element-452" data-mp="1409n2zw7ssvq" />
        <ThemeSwitcher data-id="element-453" data-mp="140rtgpclcnhd" />
      </div>
    </div>;
}